import React, { useState, } from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import { colors } from '_styles';
import moment from 'moment';
import HOC from '_HOC';
import SingleCheckbox from '../../../components/SingleCheckbox';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Header = styled.h2`
    font-size: 24px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    margin-bottom: 15px;
`;

const Title = styled.span`
    display: inline-block;
    margin: 0;
    padding: 0;
    font-size: 16px;
    text-align: left;
    font-family: Roboto, sans-serif;
`;

const NextButton = styled.button`
  position: relative;
  font-size: 14px;
  padding: 20px 0;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto 15px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const days = [
  _('zone.sun'),
  _('zone.mon'),
  _('zone.tue'),
  _('zone.wed'),
  _('zone.thu'),
  _('zone.fri'),
  _('zone.sat'),
];

const getCollectionDates = (schedule, selectedCollections) => {
  const result = {};

  schedule.forEach((yearData) => {
    yearData.months.forEach((monthData) => {
      monthData.events.forEach((event) => {
        event.collections.forEach((collection) => {
          const { id } = collection;
          const { date } = event;

          if (selectedCollections.includes(id)) {
            if (!result[id]) {
              result[id] = [];
            }
            result[id].push(date);
          }
        });
      });
    });
  });

  return Object.values(result).flat();
};

const findClosestPreviousDate = (dates) => {
  const today = new Date(); // Get today's date
  let closestDate = '';
  let closestDiff = Infinity;

  dates.forEach((dateString) => {
    const date = new Date(dateString);
    if (date <= today) {
      const diff = today - date;

      if (diff < closestDiff) {
        closestDiff = diff;
        closestDate = dateString;
      }
    }
  });

  return closestDate;
};

const MissedCollectionDay = ({ config, props }) => {
  const { history, location } = props;
  const { collection, schedule } = config;
  const { selectedCollections } = location.state;

  const selectedCollectionDates = getCollectionDates(schedule, selectedCollections);
  const closesPreviousDate = findClosestPreviousDate(selectedCollectionDates);
  const initialPreSelectedCollectionDay = closesPreviousDate ? moment(closesPreviousDate).format('dddd') : '';

  const [selectedCollectionDay, setSelectedCollectionDay] = useState(
    initialPreSelectedCollectionDay
  );

  const nextButtonHandler = () => {
    history.push('/help/form-page', {
      title: _('help.report_missed_pickup'),
      type: 'MISSED_PICKUP',
      selectedCollectionDay,
      selectedCollections,
      formDesc: `${selectedCollections.map((i) => collection[`collection-${i}`].title).join(', ')} ${selectedCollections.length > 1 ? 'were' : 'was'} not collected on ${selectedCollectionDay}.`,
      description: _('help.please_complete_and_submit_this_form')
    });
  };

  return (
    <Container>
      <Header>{_('help.when_was_the_collection_day')}</Header>

      <ul style={{ padding: 0 }}>
        {days.map((day) => (
          <li style={{ listStyle: 'none', padding: '7px 0' }}>
            <SingleCheckbox
              id={`checkbox-${day}`}
              name="checkbox"
              onClick={(event) => setSelectedCollectionDay(event.target.checked ? day : '')}
              label={<Title>{day}</Title>}
              checked={selectedCollectionDay === day}
            />
          </li>
        ))}
      </ul>
      <NextButton disabled={!selectedCollectionDay.length} onClick={() => nextButtonHandler()}>{_('help.next')}</NextButton>

    </Container>
  );
};

export default HOC(MissedCollectionDay);
